import { render, staticRenderFns } from "./gc-field-tag.vue?vue&type=template&id=cbd30e6e"
import script from "./gc-field-tag.vue?vue&type=script&lang=js"
export * from "./gc-field-tag.vue?vue&type=script&lang=js"
import style0 from "./gc-field-tag.vue?vue&type=style&index=0&id=cbd30e6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports